import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { LogoffComponent } from '../app/logoff/logoff.component';
import { AuthGuard } from '@acpgruppe/essp-ui';
import { PermissionGuard } from '@acpgruppe/essp-ui';

const appPathValue = 'skillnav';

@NgModule({
  imports: [
    RouterModule.forRoot(
      [
        {
          path: '',
          pathMatch: 'full',
          redirectTo: appPathValue,
        },
        {
          path: 'start',
          pathMatch: 'full',
          redirectTo: appPathValue,
        },
        {
          path: appPathValue,
          canActivate: [AuthGuard, PermissionGuard],
          loadChildren: () =>
            import('./core/core.module').then((l) => l.CoreModule),
        },
        {
          path: 'logout',
          pathMatch: 'full',
          component: LogoffComponent,
        },
      ],
      { enableTracing: true }
    ),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
